import { createFileRoute } from '@tanstack/react-router';
import { AddWebhookPage } from '../components/pages/BusinessPage/Webhook/AddWebhookPage';

export const Route = createFileRoute('/account/business_/webhooks_/add')({
  component: AddWebhookPage,
});
